import React from 'react'
import PropTypes from 'prop-types'
import bem from '@argos/utils/esnext/bem'

import './loading-bar.scss'

const LoadingBar = ({ loading, loadingColor }) => {
  const cn = bem({ prefix: 'ac-', block: 'loading-bar' })
  const loadingBarState = loading ? 'loading' : 'done'
  return <div className={cn(null, `${loadingBarState} background-color-${loadingColor}`)} />
}

LoadingBar.defaultProps = {
  loadingColor: 'red',
}

LoadingBar.propTypes = {
  loading: PropTypes.bool,
  loadingcolor: PropTypes.string,
}

export default LoadingBar
